/* =========================================================
   NOVARIX — Predictive Search
   Module 07: search overlay + live predictive results (AJAX)
   ========================================================= */

(function () {
  "use strict";

  var DEBOUNCE_MS = 300;
  var MIN_CHARS = 2;

  var overlay = document.querySelector("[data-search-overlay]");
  if (!overlay) return;

  var input = overlay.querySelector("[data-search-input]");
  var resultsWrap = overlay.querySelector("[data-search-results]");
  var suggestionBtns = overlay.querySelectorAll("[data-suggestion]");

  var debounceTimer;
  var lastQuery = "";
  var activeController;

  function open() {
    overlay.classList.add("is-open");
    document.body.classList.add("no-scroll");
    setTimeout(function () {
      input && input.focus();
    }, 250);
  }

  function close() {
    overlay.classList.remove("is-open");
    document.body.classList.remove("no-scroll");
  }

  function setLoading(isLoading) {
    resultsWrap.classList.toggle("is-loading", isLoading);
  }

  function runSearch(query) {
    query = (query || "").trim();
    if (query === lastQuery) return;
    lastQuery = query;

    if (query.length < MIN_CHARS) {
      resultsWrap.innerHTML = "";
      return;
    }

    if (activeController) activeController.abort();
    activeController = new AbortController();

    var predictiveUrl = window.Novarix && Novarix.routes && Novarix.routes.predictiveSearchUrl ? Novarix.routes.predictiveSearchUrl : "/search/suggest";
    var url =
      predictiveUrl +
      "?q=" +
      encodeURIComponent(query) +
      "&section_id=predictive-search&resources[type]=product,collection,query&resources[limit]=8&resources[options][unavailable_products]=last";

    setLoading(true);

    fetch(url, { signal: activeController.signal })
      .then(function (res) {
        return res.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, "text/html");
        var newResults = doc.getElementById("PredictiveSearchResults");
        if (newResults) {
          resultsWrap.innerHTML = newResults.innerHTML;
        }
        setLoading(false);
      })
      .catch(function (err) {
        if (err.name === "AbortError") return;
        setLoading(false);
      });
  }

  var debouncedSearch = function (value) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      runSearch(value);
    }, DEBOUNCE_MS);
  };

  document.querySelectorAll("[data-search-open]").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      open();
    });
  });

  overlay.querySelector("[data-search-close]")?.addEventListener("click", close);

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && overlay.classList.contains("is-open")) close();
  });

  suggestionBtns.forEach(function (btn) {
    btn.addEventListener("click", function () {
      var term = btn.dataset.suggestion;
      input.value = term;
      input.focus();
      lastQuery = "__force__";
      runSearch(term);
    });
  });

  input?.addEventListener("input", function () {
    debouncedSearch(input.value);
  });

  input?.addEventListener("keydown", function (e) {
    if (e.key === "ArrowDown") {
      var first = resultsWrap.querySelector("a, button");
      if (first) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  resultsWrap.addEventListener("keydown", function (e) {
    if (e.key !== "ArrowDown" && e.key !== "ArrowUp") return;
    var focusable = Array.prototype.slice.call(resultsWrap.querySelectorAll("a, button"));
    var idx = focusable.indexOf(document.activeElement);
    if (idx === -1) return;
    e.preventDefault();
    var nextIdx = e.key === "ArrowDown" ? idx + 1 : idx - 1;
    if (focusable[nextIdx]) focusable[nextIdx].focus();
    else if (e.key === "ArrowUp" && nextIdx < 0) input.focus();
  });
})();
